<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="`图片上传`"
    :visible.sync="visible">
    <!-- 添加水印开关 -->
    <div v-if="data.type === '23'" class="watermark-switch">
      <el-switch
        v-model="watermarkEnabled"
        active-text="添加水印"
        active-color="#13ce66">
      </el-switch>
      <el-date-picker
        size="small"
        v-model="watermarkTime"
        type="datetime"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-value="new Date()"
        placeholder="选择水印时间">
      </el-date-picker>
    </div>
    <div class="upload-list">
      <ul class="clear-both">
        <li v-for="(file, index) in files"
            :key="index">
          <div class="upload-image"
               v-loading="file.loading">
            <img :src="file.src"
                 :alt="file.src">
            <div class="upload-image-status">
              <el-button v-show="file.status === 'success'"
                         class="el-icon-success"
                         type="success"
                         size="mini"> 上传成功
              </el-button>
              <el-button v-show="file.status === 'error'"
                         class="el-icon-error"
                         type="danger"
                         size="mini"
                         @click="onUploadFile(file)"> 重新上传
              </el-button>
            </div>
            <div class="upload-image-toolbar">
              <el-button-group v-if="isShow(index)">
                <el-button type="primary"
                           icon="el-icon-edit-outline"
                           size="mini"
                           @click="onEditImage(index)"></el-button>
                <el-button type="danger"
                           icon="el-icon-delete"
                           size="mini"
                           @click="onDelete(index)"></el-button>
              </el-button-group>
            </div>
          </div>
          <div class="upload-image-date">
            <div v-if="isShow(index)"
                 v-show="modifyIndex === index"
                 role="tooltip"
                 aria-hidden="false"
                 class="el-popover el-popper modify-image-date"
                 tabindex="0"
                 x-placement="top">
              <el-date-picker
                v-model="file.datetime"
                type="datetime"
                format="yyyy:MM:dd HH:mm:ss"
                value-format="yyyy:MM:dd HH:mm:ss"
                :clearable="false"
                placeholder="选择日期时间">
              </el-date-picker>
              <div x-arrow=""
                   class="popper__arrow"
                   style="left: 85px;"></div>
            </div>
            <span @click.stop="modifyIndex = index">{{file.datetime}}</span>
          </div>
        </li>
        <li class="sj-icon-add-image">
          <input v-if="visible"
                 type="file"
                 accept="image/jpeg, image/png, image/gif"
                 multiple
                 @change="onSelectFile">
        </li>
      </ul>
    </div>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="visible = false">关 闭</el-button>
      <el-button type="primary"
                 :disabled="files.length === 0"
                 @click="onUploadFiles()">开始上传
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import {uploadOrderReviewDirectFile} from '@/views/order-review/order-review.api'
import ImgAddMark from '../../../utils/ImgAddMark'
import cropperImage from '../../CropperImage'

const URL = window.URL || window.webkitURL
export default {
  mixins: [],
  components: {},
  data () {
    return {
      request: null,
      data: {},
      name: null,
      type: null,
      callback: Function.prototype,
      visible: false,
      questionIndex: null,
      imgAddMark: null,
      files: [
        // {
        //   src: '',
        //   datetime: '2016:03:14 15:22:33',
        //   gpsLongitude: null,
        //   gpsLatitude: null,
        //   loading: false,
        //   status: '' // success error
        // }
      ],
      datetime: null,
      modifyIndex: null,
      watermarkEnabled: true, // 控制是否添加水印的开关
      watermarkTime: null,
    }
  },
  computed: {},
  watch: {
    visible (val) {
      if (!val) {
        Object.assign(this.$data, this.$options.data())
      }
    },
  },
  created () {
    document.addEventListener('click', () => {
      if (this.modifyIndex !== null) {
        this.modifyIndex = null
      }
    })
    this.$nextTick(() => {})
  },
  mounted () {},
  destroyed () {
    if (this.imgAddMark) {
      this.imgAddMark = null
      this.watermarkTime = null
    }
  },
  methods: {
    isShow (index) {
      let file = this.files[index]
      return !file.status && !file.loading
    },
    beforeAvatarUpload (file) {
      const maxSize = 10240
      const isMore = file.size / 1024 / maxSize > 1
      if (isMore) {
        this.$message.error(`上传文件大小不能超过 ${maxSize}KB!`)
      }
      return !isMore
    },
    onSelectFile (event) {
      let datetime = moment(this.datetime).format('YYYY:MM:DD HH:mm:ss')
      // 拍摄时间使用前一张照片的时间
      if (this.files.length) {
        datetime = this.files[this.files.length - 1].datetime
      }
      let files = [...event.target.files]
      files.forEach(async (file) => {
        if (this.beforeAvatarUpload(file)) {
          let processedFile = file
          let processedSrc = URL.createObjectURL(file)
          // 如果type为23，添加水印
          if (this.watermarkEnabled && this.data.type === '23') {
            try {
              if (!this.imgAddMark) {
                this.imgAddMark = new ImgAddMark()
              }
              processedFile = await this.imgAddMark.addWatermarkToImage(file, this.data.imgUrl, this.watermarkTime)
              processedSrc = URL.createObjectURL(processedFile)
            } catch (error) {
              console.error('添加水印失败:', error)
              this.$message.warning(`图片 ${file.name} 添加水印失败，将使用原图上传`)
              // 如果水印添加失败，使用原图
            }
          }
          this.files.push({
            src: processedSrc,
            datetime: datetime,
            data: processedFile,
            loading: false,
            status: '',
          })
        }
      })
    },
    /**
     * 如果未进行裁剪编辑，那么是原图上传，进行编辑仅保存需要的EXIF属性
     * @param index
     */
    onEditImage (index) {
      let file = this.files[index]
      cropperImage({
        url: file.src,
        exif: {
          datetime: file.datetime,
          // gpsLongitude: file.gpsLongitude || null,
          // gpsLatitude: file.gpsLatitude || null,
        },
        callback (blob, exif) {
          URL.revokeObjectURL(file.data)
          file.src = URL.createObjectURL(blob)
          file.datetime = exif.datetime
          // file.gpsLongitude = exif.gpsLongitude
          // file.gpsLatitude = exif.gpsLatitude
          file.data = blob
        },
      })
    },
    onDelete (index) {
      this.files.splice(index, 1)
    },
    // 获取blob的文件后缀
    getExtByBlob (blob) {
      return blob.type.split('/').pop()
    },
    // 获取二维码信息
    async decodeQRFromFileUrl (fileUrl) {
      const res = JSON.parse(await request.common('getQrcodeContentData', {url: fileUrl}).then(res => res.data))
      if (res.code === 0 && res.data.contents && res.data.contents.length > 0) {
        return res.data.contents[0]
      }
      return ''
    },
    async recognizeQrcodeData (data) {
      return request.common('getRecognizeQrcodeData', data).then(res => res.data)
    },
    // 直传
    async uploadOrderDirectFile (file) {
      file.loading = true
      let params = {
        url: this.imgAddMark.getRemarkUrl(this.data.imgUrl, this.questionIndex),
        content_type: file.data.type,
      }
      const res = await uploadOrderReviewDirectFile(params)
      if (res.data.ret === 0) {
        let uploadUrl = res.data.detail.signedUrl
        let contentType = res.data.detail.content_type
        let fileUrl = res.data.detail.url
        await fetch(uploadUrl, {
          method: 'PUT',
          headers: new Headers({
            'Content-Type': contentType
          }),
          body: file.data,
        })
        file.src = fileUrl
        file.status = 'success'
        file.loading = false
        const qrcodeContent = await this.decodeQRFromFileUrl(fileUrl)
        if (!qrcodeContent) {
          throw Error('无法识别二维码信息')
        }
        const qrcodeRes = await this.recognizeQrcodeData({
          data: qrcodeContent,
          server_image_recognize: 0,
        })
        this.callback({
          src: fileUrl,
          image_url: fileUrl,
          data: qrcodeContent,
          status: qrcodeRes.status,
        })
      } else {
        this.$message.error('上传失败')
        file.status = 'error'
      }
    },
    async onUploadFile (file) {
      if (this.request) {
        file.loading = true
        let params = {
          orderid: this.data.orderid,
          ext: this.getExtByBlob(file.data),
          content_type: file.data.type,
        }
        const res = await this.request(params)
        if (res.status === 200) {
          let uploadUrl = res.data.signedUrl
          let contentType = res.data.content_type
          let fileUrl = res.data.url
          await fetch(uploadUrl, {
            method: 'PUT',
            headers: new Headers({
              'Content-Type': contentType
            }),
            body: file.data,
          })
          file.src = fileUrl
          file.status = 'success'
          file.loading = false
          const qrcodeContent = await this.decodeQRFromFileUrl(fileUrl)
          if (!qrcodeContent) {
            this.$message.error('无法识别二维码信息')
            throw Error('无法识别二维码信息')
          }
          const qrcodeRes = await this.recognizeQrcodeData({
            data: qrcodeContent,
            server_image_recognize: 0,
          })
          this.callback({
            src: fileUrl,
            image_url: fileUrl,
            data: qrcodeContent,
            status: qrcodeRes.status
          })
        } else {
          this.$message.error('上传失败')
          file.status = 'error'
        }
      } else {
        file.status = 'error'
      }
    },
    async onUploadFiles () {
      for (const index in this.files) {
        const file = this.files[index]
        if (file.status !== 'success' && !file.loading) {
          if (this.watermarkEnabled && this.data.type === '23') {
            await this.uploadOrderDirectFile(file)
          } else {
            await this.onUploadFile(file)
          }
        }
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.watermark-switch {
  position: absolute;
  bottom: 40px;
  left: 20px;
  z-index: 10;
}

.upload-list {
  ul {
    margin: 0px;
    padding: 0px;
    list-style-type: none;

    li {
      float: left;
      margin: 10px 10px 30px;
      border: 1px solid #c0c4cc;
      width: 130px;
      height: 130px;
      position: relative;
      /**
       * 上传图片按钮
       */
      &.sj-icon-add-image {
        color: #c0c4cc;
        border: 1px solid transparent;
        font-size: 130px;
        line-height: 130px;

        input {
          cursor: pointer;
          font-size: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          position: absolute;
          top: 0px;
          left: 0px;
        }
      }

      /**
       * 图片列表
       */
      .upload-image {
        position: relative;
        vertical-align: middle;
        text-align: center;
        height: 100%;
        width: 100%;

        &::before {
          content: "";
          display: inline-block;
          height: 100%;
          vertical-align: middle;
          width: 0;
        }

        img {
          max-width: 130px;
          max-height: 130px;
          vertical-align: middle;
        }

        /**
          * 图片状态
          */
        .upload-image-status {
          position: absolute;
          width: 130px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }

        /**
          * 图片操作
          */
        .upload-image-toolbar {
          display: none;
          position: absolute;
          bottom: 8px;
          left: 0px;
          width: 130px;
          padding-top: 5px;
        }

        &:hover .upload-image-toolbar {
          display: block;
        }
      }

      /**
       * 图片创建日期
       */
      .upload-image-date {
        position: absolute;
        bottom: -28px;
        left: 0px;
        width: 130px;
        font-size: 12px;
        color: #909399;
        cursor: pointer;
        text-align: center;

        &:hover {
          color: #409eff;
        }

        .modify-image-date {
          width: 190px;
          transform-origin: center bottom 0px;
          position: absolute;
          left: -25px;
          bottom: 0px;
          margin-bottom: 27px;

          .el-date-editor.el-input {
            width: 190px;
          }

          .el-input--suffix .el-input__inner {
            padding-right: 0px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/UploadQrcode/src/main.vue